module.exports = __webpack_public_path__ + "img/@logo_shinsegae_duty@3x.ab836585.png";